import {
  Alert,
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import MarketGrowthAdminApi from "../../../../../infrastructure/api/marketGrowthAdmin";
import { formatMoney } from "../../../partner-commission/utils/formatMoney";
import {
  PARTNER_PAYOUT_STATUS_LABELS,
  getPayoutStatusChipColor,
} from "../../../partner-commission/constants/portalEnums";
import { getEnumLabel } from "../constants/commissionEnums";

const Field = ({ label, value }) => (
  <>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2" sx={{ mb: 1.5, whiteSpace: "pre-wrap" }}>
      {value ?? "—"}
    </Typography>
  </>
);

const formatDate = (value) =>
  value ? new Date(value).toLocaleString("fa-IR") : "—";

const AdminPayoutDetailDialog = ({ open, onClose, payoutId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    if (!payoutId) return;
    setLoading(true);
    setError(null);
    try {
      const res = await MarketGrowthAdminApi.getPayoutById(payoutId);
      const normalized = MarketGrowthAdminApi.normalize(
        res,
        "بارگذاری جزئیات تسویه ناموفق بود."
      );
      if (normalized.error) {
        setError(normalized.error);
        setData(null);
        return;
      }
      setData(normalized.data);
    } catch (e) {
      setError(e?.message || "خطا در بارگذاری");
    } finally {
      setLoading(false);
    }
  }, [payoutId]);

  useEffect(() => {
    if (open) load();
  }, [open, load]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>جزئیات تسویه #{payoutId}</DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : data ? (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Field label="شناسه تسویه" value={data.payoutId} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field label="شناسه نماینده" value={data.partnerId} />
            </Grid>
            <Grid item xs={12}>
              <Field label="نماینده" value={data.partnerDisplayName || data.partnerId} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field label="مبلغ" value={formatMoney(data.amount)} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">
                وضعیت
              </Typography>
              <Box sx={{ mb: 1.5 }}>
                <Chip
                  size="small"
                  label={getEnumLabel(PARTNER_PAYOUT_STATUS_LABELS, data.status)}
                  color={getPayoutStatusChipColor(data.status)}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Field label="تاریخ درخواست" value={formatDate(data.requestedAt)} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Field label="تاریخ تأیید" value={formatDate(data.approvedAt)} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Field label="تاریخ پرداخت" value={formatDate(data.paidAt)} />
            </Grid>
            <Grid item xs={12}>
              <Field label="اطلاعات حساب بانکی" value={data.bankAccountInfo} />
            </Grid>
            <Grid item xs={12}>
              <Field label="توضیحات" value={data.description} />
            </Grid>
          </Grid>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>بستن</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AdminPayoutDetailDialog;
